/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  UpdateExerciseMutationRequest,
  UpdateExerciseMutationResponse,
  UpdateExercisePathParams,
  UpdateExercise400,
  UpdateExercise401,
  UpdateExercise403,
  UpdateExercise404,
} from '../types/UpdateExercise.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getUpdateExerciseUrl(id: UpdateExercisePathParams['id']) {
  const res = { method: 'PUT', url: `/exercises/${id}` as const };
  return res;
}

/**
 * @summary Update exercise
 * {@link /exercises/:id}
 */
export async function updateExercise(
  id: UpdateExercisePathParams['id'],
  data: UpdateExerciseMutationRequest,
  config: Partial<RequestConfig<UpdateExerciseMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UpdateExerciseMutationResponse,
    ResponseErrorConfig<UpdateExercise400 | UpdateExercise401 | UpdateExercise403 | UpdateExercise404>,
    UpdateExerciseMutationRequest
  >({ method: 'PUT', url: getUpdateExerciseUrl(id).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
